import { HelpCircle } from 'lucide-react';
import React, { useContext } from 'react';
import { GlobalContext } from '../contexts/GlobalContext';

const TutorialRestartButton = ({ tutorialKey }) => {
  const { userProfile, updateTutorialFlag } = useContext(GlobalContext);

  const handleRestartTutorial = () => {
    updateTutorialFlag(tutorialKey, false);
  };

  return (
    <button
      onClick={handleRestartTutorial}
      className="fixed bottom-4 left-4 px-4 py-2 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-200 text-gray-600 hover:text-gray-800 flex items-center gap- z-10"
      title="Restart tutorial"
    >
      <HelpCircle size={20} />
      <span className="ml-2">Restart tutorial</span>
    </button>
  );
};

export default TutorialRestartButton;
